import {
  NumOfIntros,
  LeadConversion,
  IntroRevenue,
  ReferralBySource,
  TotalRevenue
} from "./modules";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom
} from "../../../utils/date-range-options";

export const MODULES = {
  leadConversion: { component: LeadConversion, height: 400 },
  introRevenue: { component: IntroRevenue, height: 400 },
  numOfIntros: { component: NumOfIntros, height: 400 },
  referralBySource: { component: ReferralBySource, height: 400 },
  totalRevenue: { component: TotalRevenue, height: 400 }
};

export const compareTypes = [
  {
    id: "previous_year",
    name: "Previous Year"
  },
  {
    id: "previous_period",
    name: "Previous Period"
  }
];

export const getInitialRangeOptions = (startDate, endDate, theBeginningOfTime) => {
  // add custom range as the last range option in range options array
  const rangeOptions = getRangeOptions(endDate, theBeginningOfTime);
  return getRangeOptionsWithCustom(rangeOptions, { payload: { startDate, endDate } }).map(
    (option) => ({
      ...option,
      // add start and end dates to the each range options object
      ...getDateRanges(
        endDate, // calendar_end_date
        { name: option.name, startDate, endDate },
        theBeginningOfTime //state.currentUser.theBeginningOfTime
      )
    })
  );
};
